import React from "react";
import type { InfoItem } from "./ui/info-list";
import { InfoList } from "./ui/info-list";
import { Card, CardContent } from "./ui/card";
import { isNotNull } from "~/lib/utils";

// Minimal interface containing only the fields this component actually uses
interface CoachDetailsProfile {
  languages: string | null;
  primaryCity: string | null;
  primaryCountry: string | null;
  coachingStyle: string | null;
  formOfConduct: string | null;
}

export const CoachDetails = ({ profile }: { profile: CoachDetailsProfile }) => {
  const coachInfo: InfoItem[] = [
    ...(profile.languages
      ? [
          {
            icon: "message",
            label: "Language",
            value: profile.languages,
          } as InfoItem,
        ]
      : []),
    ...(profile.primaryCity || profile.primaryCountry
      ? [
          {
            icon: "location",
            label: "Location",
            value: [profile.primaryCity, profile.primaryCountry]
              .filter(isNotNull)
              .join(", "),
          } as InfoItem,
        ]
      : []),
    ...(profile.coachingStyle
      ? [
          {
            icon: "palette",
            label: "Coaching style",
            value: profile.coachingStyle,
          } as InfoItem,
        ]
      : []),
    ...(profile.formOfConduct
      ? [
          {
            icon: "mic",
            label: "Form of conduct",
            value: profile.formOfConduct,
          } as InfoItem,
        ]
      : []),
  ];

  const secondaryInfo: InfoItem[] = [];

  return (
    <div className="flex flex-col gap-4">
      {0 < coachInfo.length && (
        <Card className="w-full">
          <CardContent>
            <InfoList items={coachInfo} />
          </CardContent>
        </Card>
      )}
      {0 < secondaryInfo.length && (
        <Card className="w-full">
          <CardContent>
            <InfoList items={secondaryInfo} />
          </CardContent>
        </Card>
      )}
    </div>
  );
};
